class AddressMappingFilter {
    static addressMappingFilterId: number = 0;
    id: number;//used to edit in grid

    addressList: number;
    mapping: number;
    filter: number;

    constructor(data) {
        this.id = ++AddressMappingFilter.addressMappingFilterId;
        this.addressList = data?.addressList ?? 0;
        this.mapping = data?.mapping ?? null;
        this.filter = data?.filter ?? null;
    }
}